import { CONFIG_SECTION_CODES } from '../../permissions/constants/moduleKeyMap';

export const configMenuItems = [
  {
    linkKey: 'config_menu_company',
    linkTo: '/configuracion/empresa',
    icon: 'building2',
    requiredCode: CONFIG_SECTION_CODES.EMPRESA,
  },
  {
    linkKey: 'config_menu_users',
    linkTo: '/configuracion/usuarios',
    icon: 'users',
    requiredCode: CONFIG_SECTION_CODES.USUARIOS,
  },
  {
    linkKey: 'config_menu_roles',
    linkTo: '/configuracion/roles',
    icon: 'shield',
    requiredCode: CONFIG_SECTION_CODES.PERFILES_Y_ROLES,
  },
  {
    linkKey: 'config_menu_data_management',
    linkTo: '/configuracion/gestion-datos',
    icon: 'database',
    requiredCode: CONFIG_SECTION_CODES.GESTION_DE_DATOS,
  },
  {
    linkKey: 'config_menu_roleo_automatico',
    linkTo: '/configuracion/roleo-automatico',
    icon: 'userCheck',
    requiredCode: CONFIG_SECTION_CODES.ROLEO_AUTOMATICO,
  },
  {
    linkKey: 'config_menu_protocols',
    linkTo: '/configuracion/protocolo',
    icon: 'phone',
    requiredCode: CONFIG_SECTION_CODES.PROTOCOLOS,
  },
  {
    linkKey: 'config_menu_documents',
    linkTo: '/configuracion/envio-documentos',
    icon: 'send',
    requiredCode: CONFIG_SECTION_CODES.DOCUMENTOS,
  },
  {
    linkKey: 'config_menu_integrations',
    linkTo: '/configuracion/integraciones',
    icon: 'plug',
    requiredCode: CONFIG_SECTION_CODES.INTEGRACION,
  },
  // {
  //   linkKey: 'config_menu_api_management',
  //   linkTo: '/configuracion/apis',
  //   icon: 'code',
  // },
  {
    linkKey: 'config_menu_payments',
    linkTo: '/configuracion/payments',
    icon: 'creditCard',
    requiredCode: CONFIG_SECTION_CODES.PAGOS_Y_SUSCRIPCIONES,
  },
  {
    linkKey: 'config_menu_delegations',
    linkTo: '/configuracion/suplencias',
    icon: 'userCheck',
    requiredCode: CONFIG_SECTION_CODES.SUPLENCIAS,
  },
  {
    linkKey: 'config_menu_audit_log',
    linkTo: '/configuracion/log-auditoria',
    icon: 'fileText',
    requiredCode: CONFIG_SECTION_CODES.LOG_AUDITORIA,
  },
  {
    linkKey: 'config_menu_login_log',
    linkTo: '/configuracion/log-login',
    icon: 'logIn',
    requiredCode: CONFIG_SECTION_CODES.LOG_LOGIN,
  },
  // {
  //   linkKey: 'config_menu_ip_management',
  //   linkTo: '/configuracion/gestion-ip',
  //   icon: 'network',
  // },
];
